import conicEqualArea from "./conicEqualArea.js";

export default function() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/projection/albers.js
// module id = 199
// module chunks = 0